import { JSX, useEffect } from "react";
import { DropdownItem, MultiselectDropdown } from "@app/shared/checkbox-dropdown";
import { LocationConfidenceScoresLabelEnum } from "@app/projects/enumerators";

interface LocationConfidenceFilterFilterProps {
  mappedValues: DropdownItem<LocationConfidenceScoresLabelEnum>[];
  selectedValues: DropdownItem<LocationConfidenceScoresLabelEnum>[];
  setSelectedValues: (selectedValues: DropdownItem<LocationConfidenceScoresLabelEnum>[]) => void;
  testId: string;
  title: string;
}

const LocationConfidenceFilter = (props: LocationConfidenceFilterFilterProps): JSX.Element => {
  useEffect(() => {
    props.setSelectedValues(props.mappedValues);
  }, []);

  return (
    <MultiselectDropdown
      containerClassName="d-block"
      customSelectInputText={props.selectedValues.length === props.mappedValues.length ? "All" : null}
      items={props.mappedValues}
      onSelectionChanged={(selectedValues: DropdownItem<LocationConfidenceScoresLabelEnum>[]) => { props.setSelectedValues(selectedValues) }}
      label={props.title}
      selectedItems={props.selectedValues}
      testId={props.testId}
    />
  )
}

export default LocationConfidenceFilter;
